import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'

import Container from '@components/Layout/Container'

import { HeaderSettingsDataType } from '@contracts/acf/headerSettings'
import { CustomizableComponent } from '@contracts/components/customizableComponent'

import * as styles from './PromotionalBanner.module.scss'

interface Props extends CustomizableComponent {}

const PromotionalBanner: React.FunctionComponent<Props> = (props) => {
	const data = useStaticQuery<HeaderSettingsDataType>(graphql`
		query PromotionalBannerSettings {
			wp {
				acfOptionsHeaderSettings {
					headerSettings {
						promotionalBanner {
							enabled
							message
						}
					}
				}
			}
		}
	`)

	const bannerSettings = data.wp.acfOptionsHeaderSettings.headerSettings.promotionalBanner

	const bannerClasses = [styles.banner]

	if (props.className) {
		bannerClasses.push(props.className)
	}

	if (bannerSettings.enabled) {
		return (
			<div className={bannerClasses.join(' ')}>
				<Container className={styles.container}>
					<div dangerouslySetInnerHTML={{ __html: bannerSettings.message }}></div>
				</Container>
			</div>
		)
	}

	return null
}

export default PromotionalBanner
